import { Button } from "@coval/ui"

export function MetricDefinitionsLoadWarning({
  state,
}: {
  state: { isError?: boolean; refetch: () => unknown }
}) {
  if (!state.isError) {
    return null
  }
  return (
    <div
      role="alert"
      className="flex flex-wrap shrink-0 items-center gap-3 p-4 text-sm text-coval-danger-text"
    >
      <p>
        Some metric definitions could not be loaded. Loaded results are still
        available.
      </p>
      <Button
        type="button"
        variant="secondary"
        onClick={(event) => {
          event.stopPropagation()
          void state.refetch()
        }}
      >
        Retry metric definitions
      </Button>
    </div>
  )
}
